import type { IpContent } from './types';

/**
 * Копия лендинга /ip (узбекская, латиница).
 *
 * Правишь текст страницы — правишь этот файл, больше ничего. Вёрстка в
 * routes/landing/, лоты в нишах и числа приходят из API. Источник: макет
 * docs/superpowers/specs/2026-08-14-landings-mockups/landing-ip-uz.html.
 *
 * pageTitle и heroH1 обязаны оставаться латиницей — encoding-guard.ts валит
 * сборку на кириллице в <title>/<h1> страниц /uz/.
 */
export const ipUz: IpContent = {
  kind: 'ip',
  pageTitle: "Boshlovchilar uchun davlat xaridlari — o'z hajmingizdagi tenderlar | UzTender",
  metaDescription:
    "Davlat har kuni tushlik, ta'mirlash, yetkazib berish va hatto gul sotib oladi. 100 mln so'mgacha tenderlar, buyurtmachilar kontaktlari va tushunarli tavsiflar — oyiga 79 000 so'm. Istalgan payt bekor qilinadi.",
  nav: [
    { label: 'Tenderlar', href: '#lots' },
    { label: 'Qanday boshlash', href: '#start' },
    { label: 'Narx', href: '#pricing' },
    { label: 'Savollar', href: '#faq' },
  ],
  heroKicker: "Davlat buyurtmasi bilan ishlamoqchi bo'lganlar uchun",
  heroH1: 'Davlat xaridlarida qatnashishni boshlang — kichik tenderlardan',
  heroLead:
    "Davlat har kuni tushlik, ta'mirlash, yetkazib berish va hatto gul sotib oladi. Biz 100 mln so'mgacha tenderlarni ko'rsatamiz, buyurtmachilar kontaktlarini beramiz — yangi tenderlar esa o'zi keladi.",
  // Отступление 10 (ревью владельца, 2026-08-18): хиро-CTA endi /plans'ga
  // emas — faqat «Narx» blokidagi tugma (quyida `plan.cta`) tarifni sotadi.
  ctaPrimary: "Maydonchaga o'tish",
  ctaHeader: "Maydonchaga o'tish",
  ctaSecondary: "O'z hajmimdagi tenderlarni ko'rish ↓",
  heroMicro: "Istalgan payt bekor qilasiz. Katalogni bepul ko'rish mumkin.",
  sourcesLabel: "Agar tender bizda bo'lmasa — u hech qayerda yo'q:",
  sources: ['xarid.uzex.uz', 'etender.uzex.uz', 'xt-xarid.uz'],
  // Отступление 7: см. start.uz.ts — N sourceCount'dan serverda hisoblanadi.
  sourcesMoreLabel: 'yana {count} ta maydoncha',
  sourcesUpdateNote: '· har 2 soatda yangilaymiz',
  heroChatNotice: {
    title: "🔔 «Gul» qidiruvi bo'yicha yangi tender",
    body: 'Toshkent shahri',
    time: '08:41',
  },
  heroChatReply: 'Buni men ham qila olaman 👌',
  lotsKicker: 'Reklama namunalari emas — jonli katalog',
  lotsTitle: 'Siz nima qila olasiz?',
  lotsLead:
    "O'z sohangizni tanlang — hozir ochiq turgan, 100 mln so'mgacha bo'lgan haqiqiy tenderlarni ko'rsatamiz. Istalganini ochib o'qishingiz mumkin.",
  niches: [
    { key: 'auto', label: "Avtota'mirlash", categoryName: 'Avtomobil va transport' },
    { key: 'food', label: 'Ovqat va oziq-ovqat', categoryName: 'Oziq-ovqat mahsulotlari' },
    { key: 'transport', label: 'Yetkazib berish', categoryName: 'Transport va logistika' },
    { key: 'cleaning', label: 'Tozalash xizmatlari', categoryName: 'Klining va sanitariya' },
    { key: 'it', label: 'Kompyuter va IT', categoryName: 'IT va telekommunikatsiya' },
    { key: 'furniture', label: 'Mebel va ofis', categoryName: 'Mebel va interyer' },
    { key: 'textile', label: "To'qimachilik", categoryName: "To'qimachilik va kiyim" },
    { key: 'flowers', label: "Gullar va ko'kalamzorlashtirish", categoryName: "Qishloq xo'jaligi" },
  ],
  foundTemplate: '«{category}» toifasida hozir {count} ta faol {word}',
  seeAllLabel: "hammasini ko'rish →",
  // Отступление 11 (ревью владельца, 2026-08-20): «1/5» (21,7%, отступление 8)
  // «1/3»ga almashtirildi — bu yangi o'lchov emas, balki pol/shift oralig'i
  // ichidagi halol baho: g'olibsiz yopilgan tenderni FAQAT bitta manba
  // (etender) qayd etadi, qolganlari faqat yutuqlarni saqlaydi. Shuning uchun
  // barcha manbalar bo'yicha ulush (90 kunda 21,7%) — bu POL, fakt emas:
  // yutuqsiz holatni yozmaydigan manbalar uni pastga tortadi. To'liq
  // trekingli yagona manba — etender'da esa 90 kunda 56% / butun davrda 88%:
  // bu SHIFT. «1/3» (≈27–33%) shu oraliq ICHIDA — analitikning ehtiyotkor
  // bahosi, maketdagi raqam emas. Rus tilidagi fayldagi kabi (ip.ru.ts),
  // faqat kirilcha «1 из 3» emas — uzbekcha faylda lotin raqami saqlanadi.
  factBig: '1/3',
  factBody:
    "Har 3 tenderdan biri g'olibsiz yopiladi — buyurtmachi yetkazib beruvchi topolmaydi. Raqobat siz o'ylagandan past.",
  lotsCta: 'Butun katalogni ochish — bepul',
  lotsMicro:
    "Ro'yxatdan o'tish shart emas. Hudud, toifa va summa bo'yicha filtrlar. Tavsiflar o'zbek va rus tillarida.",
  fearsTitle: 'Boshlashdan oldingi uch ikkilanish',
  fearsLead: 'Ularni har kuni eshitamiz. Qisqa javob beramiz.',
  fears: [
    {
      q: '«Umuman ariza qanday topshiriladi?»',
      title: "Qo'llanma bor — 15 daqiqa",
      body: "YaTT ochishdan birinchi arizagacha, bosqichma-bosqich. Qo'llanmani ochish — bepul.",
    },
    {
      q: "«Buni sarmoyasiz qilsa bo'ladimi?»",
      title: 'Katta pul shart emas',
      // Отступление 3.
      body: "Kichik tenderlarda ta'minot puli kichik: masalan, 25 mln so'mlik tenderda 250 000 so'm. Xizmatlarda tovarni oldindan olish shart emas.",
    },
    {
      q: "«Talablarda tushunarsiz narsa bo'lsa-chi?»",
      title: "Buyurtmachidan to'g'ridan-to'g'ri so'rang",
      body: "Obunada har bir tenderda buyurtmachining kontakti bor — ariza topshirishdan oldin qo'ng'iroq qilib aniqlashtiring.",
    },
  ],
  valueTitle: "79 000 so'mlik obuna nima beradi",
  values: [
    {
      title: 'Oyiga 5 ta buyurtmachi kontakti',
      body: "Sizga mos kelgan tenderlar bo'yicha buyurtmachining telefoni va ma'lumotlari. Oyiga 1–2 ta arizaga bemalol yetadi.",
    },
    {
      title: 'Faqat 100 mln gacha tenderlar',
      body: "Milliardlik qurilishlarsiz. Kichik firma yoki YaTT haqiqatan qo'li yetadigan ishlarni ko'rasiz.",
    },
    {
      title: "Yangi tenderlar o'zi keladi",
      body: "Qidiruvni saqladingiz — masalan, «ta'mirlash, Farg'ona» — yangilari bildirishnoma bo'lib keladi. Katalogni varaqlash shart emas.",
    },
    {
      title: 'Nima talab qilinishi tushunarli',
      body: "Har bir tenderda qisqa tavsif bor — o'zbek va rus tillarida: nima kerak, qancha va qachongacha.",
    },
  ],
  // Отступление 9 (ревью владельца, 2026-08-18): eski 4 qadam obunadan
  // OLDINGI yo'lni tasvirlar edi. Yangilari — servis ICHIDAGI yo'l.
  stepsTitle: 'Qanday boshlash — 4 qadam',
  steps: [
    { title: "UzTender'da ro'yxatdan o'ting", body: 'Bepul, bir daqiqada' },
    { title: 'Bildirishnomalarni sozlang', body: "Sohangizni saqlang — yangilari o'zi keladi" },
    { title: 'Mos tenderni tanlang', body: "Kelganlaridan yoki to'g'ridan-to'g'ri katalogdan" },
    { title: 'Maydoncha saytida ariza topshiring', body: 'xarid.uzex.uz yoki xt-xarid.uz saytida' },
  ],
  stepsCta: "Yetkazib beruvchilar uchun qo'llanmani ochish — bepul",
  stepsMicro:
    "Qo'llanmada har bir qadam yoritilgan: hujjatlar, muddatlar va yangi boshlovchilarning tez-tez xatolari.",
  pricingTitle: "Bitta tarif. Mayda shrift yo'q",
  plan: {
    name: 'YaTT',
    priceMonthly: "79 000 so'm/oy",
    priceYearly: null,
    wasYearly: null,
    noteMonthly: '',
    noteYearly: '',
    features: [
      'Oyiga 5 ta buyurtmachi kontakti',
      "Byudjeti 100 mln so'mgacha bo'lgan tenderlar",
      'Cheksiz saqlangan qidiruv + bildirishnomalar',
      'TT tahlili va talablar — bepul',
    ],
    yearlyOnlyFeatures: [],
    // Отступление 8.
    cta: "79 000 so'mdan boshlash",
    highlighted: true,
    flag: null,
    note: null,
  },
  planMicro: "To'lov Payme orqali · Istalgan payt bekor qilinadi",
  mathTitle: 'Oddiy hisob-kitob',
  // Отступление: «10% ustama» → «25% foyda» — 30 mln'ning 25% i 7 500 000,
  // 7 500 000 / 79 000 = 94,9 → 94 oy (o'zbek tilida son bilan ot
  // o'zgarmaydi, shu uchun bir xil «oyga» so'zi ishlatiladi, см. ip.ru.ts).
  mathRows: [
    { label: 'Bitta tender yutdingiz', value: "30 mln so'm", highlight: false },
    { label: 'Foydangiz 25%', value: "7 500 000 so'm", highlight: true },
    { label: 'Oylik obuna', value: "79 000 so'm", highlight: false },
    { label: 'Bu pul yetadi', value: '94 oyga', highlight: true },
  ],
  mathMicro: "Bunday hajmdagi tenderlar har kuni chiqadi — yuqorida ko'rdingiz, hammasi haqiqiy.",
  upsell:
    "Ko'p ariza topshirasizmi? Pro bor — oyiga 399 000 so'm: cheksiz kontaktlar, tender hujjatlari va g'oliblar narxi.",
  teamTitle: 'Bu xizmat ortida kim turibdi',
  // Отступление 4: команда — две карточки (CEO + CTO), тот же блок, что на
  // /uz/start, без официоза — фото крупнее. Отступление 6 (2026-08-18): `bio`
  // olib tashlandi — kartochka endi faqat foto + ism + rol.
  team: [
    {
      name: 'Igor Kim',
      role: 'CEO',
      photo: '/img/team/igor.jpg',
      initials: 'IK',
      links: [
        { label: '@flesteyto', href: 'https://t.me/flesteyto', primary: true },
        { label: '+998 90 187-77-98', href: 'tel:+998901877798', primary: false },
      ],
    },
    {
      name: 'Konstantin Tsoy',
      role: 'CTO',
      photo: '/img/team/konstantin.jpg',
      initials: 'KT',
      links: [],
    },
  ],
  // Отступление 5: «IT Park rezidenti» не публикуем.
  fineprint: [
    { label: '«FASTAGO» MChJ', href: null },
    { label: 'STIR 306377222', href: null },
    { label: 'Toshkent', href: null },
    { label: "To'liq rekvizitlar →", href: '/requisites' },
  ],
  faqTitle: "Ko'p beriladigan savollar",
  faq: [
    {
      q: 'MChJ kerakmi yoki YaTT yetadimi?',
      a: "Ko'pchilik kichik tenderlar uchun YaTT yetadi. Har bir tenderning talablari kartochkasida ko'rinadi. Qachon MChJ kerakligi qo'llanmada yozilgan.",
    },
    // Отступление 6: вопрос «ERI qancha turadi va qayerdan olinadi?» убран целиком.
    {
      q: 'Boshlash uchun garov yoki katta pul kerakmi?',
      a: "Kichik tenderlarda ta'minot puli — summaning kichik foizi. Masalan, 25 mln so'mlik tenderda 250 000 so'm. Aniq summa har doim ariza topshirishdan oldin kartochkada ko'rinadi. Xizmatlarda tovarni oldindan olish shart emas.",
    },
    {
      q: "Mening sohamda tender bo'lmasa-chi?",
      a: "To'lovdan oldin tekshiring — katalog ochiq: 31 ta toifa va barcha 14 hudud. Ikkilansangiz — bizga yozing, sohangizni birga ko'ramiz.",
    },
    {
      q: "YaTT tarifi Pro'dan nimasi bilan farq qiladi?",
      a: "YaTT (79 000 so'm) — boshlash uchun: 100 mln gacha tenderlar va oyiga 5 ta kontakt. Pro (399 000 so'm) — cheksiz kontaktlar, tender hujjatlari, g'oliblar narxi, Telegram-bot. Istalgan payt Pro'ga o'tish mumkin.",
    },
    {
      q: 'Obunani qanday bekor qilaman?',
      a: "Istalgan payt, shaxsiy kabinetda ikki klik bilan. To'langan muddat oxirigacha kirish saqlanadi, keyin pul yechilmaydi.",
    },
  ],
  finalH2: 'Siz qila oladigan ishlarni davlat allaqachon sotib olyapti',
  // Отступление 9: «Bugun» → «bir haftada» ({count} подставляет страница).
  finalLead:
    "Savol faqat — kimdan. Bir haftada katalogda {count} ta yangi {word} paydo bo'ldi. Ular orasida sizniki ham bor.",
  // Отступление 10.
  finalCtaPrimary: "Maydonchaga o'tish",
  footerLinks: [
    { label: 'Xizmat haqida', href: '/about' },
    { label: "Yetkazib beruvchilar uchun qo'llanma", href: '/guide' },
    { label: 'Tariflar', href: '/plans' },
    { label: 'Ommaviy oferta', href: '/offer' },
    { label: 'Maxfiylik', href: '/privacy' },
    { label: 'Rekvizitlar', href: '/requisites' },
    { label: '@flesteyto', href: 'https://t.me/flesteyto' },
    { label: '+998 90 187-77-98', href: 'tel:+998901877798' },
  ],
  footerLegal: '© 2026 «FASTAGO» MChJ. Barcha huquqlar himoyalangan. STIR: 306377222',
  stickyTitle: "Oyiga 79 000 so'm",
  stickySubtitle: 'istalgan payt bekor qilinadi',
  // Отступление 10.
  stickyCta: "Maydonchaga o'tish",
};
